import getSubdomain from "./getSubdomain";

export async function uploadSubStationImageHelper({
  subStationId,
  file,
  uploadImage,
  setSubStationInputs,
  refetchStations,
  getImageUrl,
  showToast,
}) {
  if (!subStationId || !file)
    return { ok: false, err: new Error("missing args") };

  const tryUpload = async (type) => {
    try {
      const res = await uploadImage({
        id: subStationId,
        subdomain: getSubdomain(),
        data: file,
        imageType: type,
      }).unwrap();
      return { ok: true, res };
    } catch (err) {
      return { ok: false, err };
    }
  };

  let result = await tryUpload("substation");
  if (!result.ok) {
    const err = result.err;
    const message = err?.data?.message || err?.message || "";
    if (message && message.toLowerCase().includes("invalid image type")) {
      result = await tryUpload("station");
    }
  }

  if (result.ok) {
    const r = result.res;
    const imageName = r?.image_name || r?.data?.image_name || null;
    if (imageName && typeof setSubStationInputs === "function") {
      setSubStationInputs((prev) =>
        prev.map((s) =>
          s.id === subStationId
            ? {
                ...s,
                image_name: imageName,
                preview: getImageUrl(imageName),
                imageFile: null,
              }
            : s,
        ),
      );
    }
    try {
      if (typeof refetchStations === "function") await refetchStations();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("refetchStations failed:", e);
      if (showToast)
        showToast(
          "error",
          "Station",
          "Unable to refresh station data after image upload",
        );
    }
    return { ok: true, res: result.res };
  }

  // eslint-disable-next-line no-console
  console.info("Substation image upload failed:", result.err);
  return { ok: false, err: result.err };
}

export default uploadSubStationImageHelper;
